export const orgListingGet = (data) => {
    return data.data;
}
export const orgCreatePost = (data) => {
    return data.data;
}
export const orgDetailsGet = (data) => {
    return data.data;
}
export const orgUpdatePatch = (data) => {
    return data.data;
}
export const orgUpdatePatchApi = (data) => {
    return data.data;
}
export const organizationDeleteApi = (data) => {
    return data.data;
}
export const addUserPost = (data) => {
    return data.data;
}
export const addUserPatch = (data) => {
    return data.data;
}

export const orgCustRelationPostApi = (data) => {
    return data.data;
}

export const userDetailsGet = (data) => {
    return data.data;
}
export const userMessageBalances = (data) => {
    return data.data;
}

export const userDeleteApi = (data) => {
    return data.data;
}
export const usersInfoPost = (usersInfoAdd) => {
    return usersInfoAdd.data
}
export const usersInfoPatch = (usersInfoUpdate) => {
    return usersInfoUpdate.data
}
export const createOrgSettingPost = (data) => {
    return data.data
}
export const orgSettingGet = (data) => {
    return data.data
}

export const orgActivatePhoneNumberPost = (data) => { //imtiaj
    return data.data
}

export const getPhoneNumberActivateStatusGet = (data) => { //imtiaj
    return data.data
}
export const controlPanelPost = (data) => { //imtiaj
    return data.data
}
export const controlPanelPostget = (data) => { //imtiaj
    return data.data
}

export const webhookSettingPanelPost = (data) => {
    return data.data
}

export const webhookSettingPanelPatch = (data) => {
    return data.data
}
